import type {
  CreateInvitationBody,
  Invitation,
  InvitationPreview,
  MailSettings,
  RegisterBody,
  TestMailBody,
  TestMailResponse,
  UpdateMailSettingsBody,
  User,
} from '@tasks/contracts';

import type { Page } from '../lib/types';
import { apiRequest } from './client';

export type ListInvitationsParams = {
  readonly status?: 'pending' | 'expired' | 'accepted' | 'revoked';
  readonly limit?: number;
  readonly offset?: number;
};

/** Список приглашений для админки (UC-USR-06, docs/05 §3). */
export function listInvitations(
  params: ListInvitationsParams = {},
  signal?: AbortSignal,
): Promise<Page<Invitation>> {
  return apiRequest<Page<Invitation>>('/admin/invitations', {
    query: { status: params.status, limit: params.limit, offset: params.offset },
    signal,
  });
}

export function createInvitation(body: CreateInvitationBody): Promise<Invitation> {
  return apiRequest<Invitation>('/admin/invitations', { method: 'POST', body });
}

/** Повторная отправка: старый токен гаснет, срок продлевается. */
export function resendInvitation(id: string): Promise<Invitation> {
  return apiRequest<Invitation>(`/admin/invitations/${encodeURIComponent(id)}/resend`, {
    method: 'POST',
  });
}

export function revokeInvitation(id: string): Promise<void> {
  return apiRequest<void>(`/admin/invitations/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

// --- Почта (UC-ADM-01) ---

export function getMailSettings(signal?: AbortSignal): Promise<MailSettings> {
  return apiRequest<MailSettings>('/admin/settings/mail', { signal });
}

export function updateMailSettings(body: UpdateMailSettingsBody): Promise<MailSettings> {
  return apiRequest<MailSettings>('/admin/settings/mail', { method: 'PUT', body });
}

export function sendTestMail(body: TestMailBody): Promise<TestMailResponse> {
  return apiRequest<TestMailResponse>('/admin/settings/mail/test', { method: 'POST', body });
}

// --- Публичная регистрация (UC-AUTH-09) ---

export function fetchInvitationPreview(token: string, signal?: AbortSignal): Promise<InvitationPreview> {
  return apiRequest<InvitationPreview>(`/auth/invitations/${encodeURIComponent(token)}`, { signal });
}

export function registerByInvitation(body: RegisterBody): Promise<{ user: User }> {
  return apiRequest<{ user: User }>('/auth/register', { method: 'POST', body });
}
